import { styled } from "@linaria/react";
const _exp = /*#__PURE__*/() => p => p.targetWidth;
export const MarkdownOverlayEditorStyle = /*#__PURE__*/styled('div')({
  name: "MarkdownOverlayEditorStyle",
  class: "gdg-m1pnx84e",
  propsAsIs: false,
  vars: {
    "m1pnx84e-0": [_exp(), "px"]
  }
});

